var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69011 0.0458984C1.65212 0.0458984 0 1.69802 0 3.73602V10.2922C0 12.3301 1.65212 13.9823 3.69011 13.9823H14.5731C16.6111 13.9823 18.2633 12.3301 18.2633 10.2921V3.73601C18.2633 1.69802 16.6111 0.0458984 14.5731 0.0458984H3.69011ZM2.72965 1.91685C3.01634 1.76517 3.3432 1.67928 3.69011 1.67928H14.5731C14.9204 1.67928 15.2475 1.76533 15.5344 1.91727L10.9228 6.19957C9.9132 7.13712 8.3513 7.13712 7.34167 6.19957L2.72965 1.91685ZM1.70536 3.1947C1.65843 3.36718 1.63338 3.54867 1.63338 3.73602V10.2922C1.63338 11.4281 2.55421 12.3489 3.69011 12.3489H14.5731C15.709 12.3489 16.6299 11.4281 16.6299 10.2921V3.73601C16.6299 3.549 16.6049 3.36782 16.5582 3.19562L12.0343 7.39648C10.3979 8.91598 7.86655 8.91599 6.23022 7.39648L1.70536 3.1947Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.9a78af9b2e69f1fa01fd686daa6faf7f.svg";
export { ForwardRef as ReactComponent };